import { Component, Input } from '@angular/core';

@Component({
  selector: 'c-tab',
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.css',
  standalone: false,
})
export class TabComponent {
  @Input() label!: string;
  active = false;
}
